import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "../../components/ui/dialog";

const Field = ({ id, label, value, onChange }) => (
  <div><Label className="eyebrow">{label}</Label>
    <Input type="password" value={value} onChange={(e) => onChange(e.target.value)} className="mt-2 rounded-sm" data-testid={id} /></div>
);

// target = null -> change own password; target = user -> partner/admin sets a new one
export default function PasswordDialog({ open, onClose, target }) {
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const close = () => { setF({ current: "", next: "", confirm: "" }); onClose(); };

  const save = async () => {
    if (f.next.length < 6) return toast.error("New password must be at least 6 characters");
    if (f.next !== f.confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      if (target) await api.post(`/users/${target.id}/set-password`, { new_password: f.next });
      else await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success(target ? `Password reset for ${target.name}. They have been signed out everywhere.` : "Password changed. Other devices have been signed out.");
      close();
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-md" data-testid="password-dialog">
        <DialogHeader>
          <DialogTitle>{target ? `Reset password — ${target.name}` : "Change password"}</DialogTitle>
          <DialogDescription>At least 6 characters. {target ? "Share the new password with the employee." : ""}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          {!target && <Field id="pw-current" label="Current password" value={f.current} onChange={(v) => setF({ ...f, current: v })} />}
          <Field id="pw-new" label="New password" value={f.next} onChange={(v) => setF({ ...f, next: v })} />
          <Field id="pw-confirm" label="Confirm new password" value={f.confirm} onChange={(v) => setF({ ...f, confirm: v })} />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={close}>Cancel</Button>
          <Button onClick={save} disabled={busy} data-testid="pw-save-btn">{busy ? "Saving…" : "Save password"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
